import { render } from "./change-email.vue?vue&type=template&id=7f1162a1"
import script from "./change-email.vue?vue&type=script&lang=js"
export * from "./change-email.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__